import(/* webpackMode: "eager", webpackExports: ["LandingEntry"] */ "/app/apps/web/src/components/landing/landing-entry.tsx");
